// The seam for NPC schedules (daily routines tied to the time of day, decision 0049). Phase D1 builds them (gate
// D1.3: townsfolk follow their routines); phase B leaves only the shape, so a behaviour tree can already ask "what
// should I be doing now" through a registered condition or action without knowing who answers.

/** One block of a routine: from `from` to `to` (hours, 0 to 24, wrapping past midnight), do `activity` at `place`. */
export interface RoutineBlock {
  from: number;
  to: number;
  activity: string;
  place: string;
}

/** Answers what an agent should be doing at a time of day. D1's routines implement it; a test can stub it. */
export interface ScheduleSource {
  /** The block for `agent` at `hour` (0 to 24), or null when it has none (free time: its tree decides). */
  at(agent: string, hour: number): RoutineBlock | null;
}

/** A schedule with no routines (every agent free): the stub until D1. */
export const NO_SCHEDULE: ScheduleSource = { at: () => null };

/** The block of a routine covering `hour` (blocks may wrap past midnight), or null. */
export function blockAt(routine: readonly RoutineBlock[], hour: number): RoutineBlock | null {
  const h = ((hour % 24) + 24) % 24;
  for (const b of routine) {
    if (b.from <= b.to ? h >= b.from && h < b.to : h >= b.from || h < b.to) return b;
  }
  return null;
}
